import {createAsyncThunk} from "@reduxjs/toolkit";
import {HOSTNAME} from "../configs/Domain";
import {prepareJsonPayload} from "../store/utils";
import {handleError} from "./_apiUtils";


export const createPortfolioPath = createAsyncThunk(
  'user/createPortfolioPath',
  async ({ data }, { rejectWithValue }) => {
    try {

      const response =  await fetch(`${HOSTNAME}/user/path/create`, prepareJsonPayload({
            data: data ,
            method: 'POST',
        }));
      const pathData = await response.json();
      return pathData;
    } catch (error) {
      return handleError(error, { rejectWithValue });
    }
  }
);
export const updatePortfolioPath = createAsyncThunk(
  'user/updatePortfolioPath',
  async ({ pathId, data }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/user/path/${pathId}/update`, prepareJsonPayload({
        data: data,
        method: 'POST',
      }));
      const updatedPathData = await response.json();
      return updatedPathData;
    } catch (error) {
      return handleError(error, { rejectWithValue });
    }
  }
);
export const removePortfolioPath = createAsyncThunk(
  'user/removePortfolioPath',
  async ({ pathId }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/user/path/${pathId}/delete`, prepareJsonPayload({
        method: 'DELETE',
      }));
      const result = await response.json();
      return result;
    } catch (error) {
      return handleError(error, { rejectWithValue });
    }
  }
);
